import axios from "axios";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";

const ReviewForm = () => {
      const [loading, setLoading] = useState(false);
    
 const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [organization, setOrganization] = useState("");
  const [review, setReview] = useState("");
  const [rating, setRating] = useState("");

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    console.log(rating);
    if ((!name || !email || !review || !rating, !phone, !organization)) {
      toast.error("All fields are required!");
      return;
    }
    try {
      const response = await axios.post("https://backend.maplecloudtechnologies.com:7443/reviews/save", {
        name,
        email,
        review,
        phone,
        rating,
        organization,
      });

      toast.success("Review submitted successfully !");
      console.log(response.data);
      setName("");
      setEmail("");
      setPhone("");
      setRating("");
      setOrganization("");
      setReview("");
      setLoading(false);
    } catch (error) {
      toast.error("Error submitting review");
      console.error(error);
      setLoading(false);
    }
  };

    return(
        <div className=" py-20 flex items-center justify-center bg-black/60 z-50">
                <Toaster position="top-right" reverseOrder={false} />
          
          <form
            onSubmit={handleSubmit}
            className="bg-[#181818] w-[520px] p-8 rounded-xl border border-cyan-700 shadow-xl relative"
          >
          

            {/* Title */}
            <h2 className="text-2xl text-white text-center mb-1">
              Give Review
            </h2>

            {/* Name */}
            <label className="text-gray-300 text-sm block mb-2">
              Your Name
            </label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              required
              className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm px-4 py-3 rounded-lg outline-none focus:border-cyan-500 mb-4"
              placeholder="Enter your name..."
            />
            <label className="text-gray-300 text-sm block mb-2">Phone</label>
            <input
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              type="tell"
              required
              className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm px-4 py-3 rounded-lg outline-none focus:border-cyan-500 mb-4"
              placeholder="Enter phone"
            />
            <label className="text-gray-300 text-sm block mb-2">
              organization
            </label>
            <input
              value={organization}
              onChange={(e) => setOrganization(e.target.value)}
              type="text"
              className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm px-4 py-3 rounded-lg outline-none focus:border-cyan-500 mb-4"
              placeholder="Enter organization name..."
            />

            {/* Email */}
            <label className="text-gray-300 text-sm block mb-2">
              Your Email
            </label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm px-4 py-3 rounded-lg outline-none focus:border-cyan-500 mb-4"
              placeholder="example@gmail.com"
            />
            {/* Profile */}
            {/* <label className="text-gray-300 text-sm block mb-2">
              Add Profile Picture
            </label>
            <input
              type="file"
              className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm rounded-lg outline-none focus:border-cyan-500 mb-4 file:h-full file:bg-cyan-600 file:cursor-pointer file:px-3 file:py-3 file:text-white file:border-none file:bg-transparent"
              placeholder="example@gmail.com"
            /> */}

            {/* Rating */}
            <label className="text-gray-300 text-sm block mb-2">
              Rate Your Experience
            </label>
            <div className="flex gap-2 mb-5 text-yellow-400 text-2xl cursor-pointer">
              {[1, 2, 3, 4, 5].map((star) => (
                <span key={star} onClick={() => setRating(star)}>
                  {rating >= star ? "★" : "☆"}
                </span>
              ))}
            </div>

            {/* Review */}
            <label className="text-gray-300 text-sm block mb-2">
              Do you have any thoughts you'd like to share?
            </label>
            <textarea
              value={review}
              onChange={(e) => setReview(e.target.value)}
              rows={2}
              required
              className="w-full bg-[#0f0f0f] border border-gray-700 text-gray-200 text-sm p-2 rounded-lg outline-none focus:border-cyan-500 mb-6"
              placeholder="Write review here..."
            />

            {/* Buttons */}
            <div className="flex gap-4">
              <button
                type="submit"
                className="flex-1 bg-cyan-600 hover:bg-cyan-500 text-white py-2 rounded-lg"
              >
                {loading ? "Sumitting..." : "Submit Review"}
              </button>
             
            </div>
          </form>
        </div>
    )
}

export default ReviewForm;